import { render } from "./Address.vue?vue&type=template&id=cfafec26&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=cfafec26&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfafec26"],['__file',"src/assets/js/pages/AddMeterConfig/Address.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfafec26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfafec26', __exports__)) {
    api.reload('cfafec26', __exports__)
  }
  
  module.hot.accept("./Address.vue?vue&type=template&id=cfafec26&scoped=true", () => {
    api.rerender('cfafec26', render)
  })

}


export default __exports__